export const NOT_FOUND_URL = "/page_404";
